const KEY = 'cv-portal:header-nav-redesign-spotlight-seen-v1';

export const getHeaderNavSpotlightSeen = (): boolean =>
    localStorage.getItem(KEY) === 'true';

export const setHeaderNavSpotlightSeen = (): void =>
    localStorage.setItem(KEY, 'true');
